<div class="print-view-container">
  <agr-print-page [showHeaderImage]="false" [showPageNumber]="false">
    <div class="print-header">
      <div class="header-title">{{ 'insemination-advice.print.header-title' | translate }}</div>
      <div class="measurement-date">
        {{ 'insemination-advice.print.measurementDate' | translate }}:
        {{ measurementDateFn() | agrDate: 'mediumDate' }}
      </div>
    </div>

    <div class="alva-metrics-section">
      <h3>{{ 'insemination-advice.print.alva-overview-title' | translate }}</h3>
      <div class="metric-row">
        <span class="metric-title">{{
          'insemination-advice.alva.expected-alva-title' | translate
        }}</span>
        <span class="metric-value">
          <ng-container *ngIf="alvaMetrics?.expectedAlvaMonths != null; else noInfo">
            {{ alvaMetrics.expectedAlvaMonths }}
            {{ 'insemination-advice.alva.months-unit' | translate }}
          </ng-container>
        </span>
      </div>
      <div class="metric-row">
        <span class="metric-title">{{
          'insemination-advice.alva.potential-alva-title' | translate
        }}</span>
        <span class="metric-value">
          <ng-container *ngIf="alvaMetrics?.dairyStartAlvaMonths != null; else noInfo">
            {{ alvaMetrics.dairyStartAlvaMonths }}
            {{ 'insemination-advice.alva.months-unit' | translate }}
          </ng-container>
        </span>
      </div>
      <div class="metric-row">
        <span class="metric-title">{{
          'insemination-advice.alva.phosphate-title' | translate
        }}</span>
        <span class="metric-value">
          <ng-container *ngIf="alvaMetrics?.phosphateDifferenceKg != null; else noInfo">
            {{ alvaMetrics.phosphateDifferenceKg }}
            {{ 'insemination-advice.alva.kg-unit' | translate }}
          </ng-container>
        </span>
      </div>

      <ng-template #noInfo>{{ 'insemination-advice.alva.no-information' | translate }}</ng-template>
    </div>

    <hr />

    <table class="print-table">
      <thead>
        <tr>
          <th>{{ 'insemination-advice.columns.animal-id' | translate }}</th>
          <th>{{ 'insemination-advice.columns.ear-number' | translate }}</th>
          <th>{{ 'insemination-advice.columns.name' | translate }}</th>
          <th>{{ 'insemination-advice.columns.age' | translate }}</th>
          <th>{{ 'insemination-advice.columns.height' | translate }}</th>
          <th>{{ 'insemination-advice.columns.estimated-height' | translate }}</th>
          <th>{{ 'insemination-advice.columns.last-insemination' | translate }}</th>
          <th>{{ 'insemination-advice.columns.advice' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of printTableDataFn()" [ngClass]="row.className">
          <td>{{ row.number }}</td>
          <td>{{ row.earNumber }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.ageInMonths | number: '1.1-1' }} mnd.</td>
          <td>{{ row.hipHeight }}</td>
          <td>{{ row.estimatedHipHeight }}</td>
          <td>{{ row.lastInsemination ? (row.lastInsemination | agrDate: 'shortDate') : '' }}</td>
          <td>{{ row.advice }}</td>
        </tr>
      </tbody>
    </table>
  </agr-print-page>

  <div class="print-logo-lastpage">
    <div class="logo-container" *ngIf="showLogo">
      <img src="assets/img/agrifirm-logo.png" alt="Agrifirm" (error)="onLogoError()" />
    </div>
  </div>
</div>
